import styled, { css } from 'styled-components/macro'
import { ifProp } from 'styled-tools'
import { em, calcEm } from '../../utils/styles'

const SuccessMessage = styled.article`
  padding: ${calcEm(40, 24)} 0 0;
  font-size: ${em(24)};
  text-align: center;
  ${ifProp('trailer', css`
    margin-bottom: ${calcEm(30, 24)};
  `)}
`

export default SuccessMessage
